
export const filterCategoriesByTime = (categories, now = new Date()) => {
  const currentDay = now.toLocaleDateString("en-US", { weekday: "long" });
  const currentTime = now.toTimeString().slice(0, 5);

  const isTimeInSlot = (time, slot) => {
    const [start, end] = slot.split("-");
    return time >= start && time <= end;
  };

  return categories.filter(cat => {
    if (!cat.category_time_slots) return true;
    const dayConfig = cat.category_time_slots[currentDay];
    if (!dayConfig || dayConfig.status !== 1) return false;
    return dayConfig.slots.some(slot => isTimeInSlot(currentTime, slot));
  });
};
export const filterCategoriesByMenu = (categories, menuItems) => {
  if (!categories || !menuItems) return [];

  // Create a set of category IDs that have at least one item
  const categoryIdsWithItems = new Set(
    menuItems.map(item => item.category_id || item.item_category_id)
  );

  return categories.filter(category => categoryIdsWithItems.has(category.category_id));
};
